// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
//import VueRouter from "vue-router";
//import Vuex from 'vuex' // https://vuex.vuejs.org/fr/
import 'es6-promise/auto'
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueGoodTablePlugin from 'vue-good-table';
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import '@fortawesome/fontawesome-free/css/all.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'vue-good-table/dist/vue-good-table.css'
//import Vueditor from 'vueditor'
import Vue2Editor from "vue2-editor";

import router from './router'
import store from "./store/store"

import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/fr';

dayjs.extend(relativeTime);
dayjs.locale('fr');

Vue.config.productionTip = false

Vue.use(Vue2Editor);
//Vue.use(Vueditor, config);
Vue.use(VueAxios, axios);
Vue.use(VueGoodTablePlugin);

library.add(fas);
library.add(fab);
Vue.component('font-awesome-icon', FontAwesomeIcon);


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js